import { render, staticRenderFns } from "./CollapseTransition.vue?vue&type=template&id=2b2189f3&scoped=true&"
import script from "./CollapseTransition.vue?vue&type=script&lang=js&"
export * from "./CollapseTransition.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTransition.vue?vue&type=style&index=0&id=2b2189f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2189f3",
  null
  
)

export default component.exports